<template>
  <v-container id="smslogs" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="12">
        <base-material-card
          color="cyan"
          icon="mdi-filter"
          class="px-3 py-1 small-icon"
        >
          <v-row>
            <v-col cols="12" md="2" lg="2">
              <toggle-button
                v-model="filter.monthly"
                :labels="{
                  checked: $i18n.t('Month-Wise Report'),
                  unchecked: $i18n.t('Day-Wise Report'),
                }"
                class="my-6"
                :height="25"
                :width="170"
                :font-size="14"
                @change="search"
              />
            </v-col>
            <v-col cols="12" sm="3" md="2" lg="2" v-if="!filter.monthly">
              <v-select
                :items="dayList"
                v-model="filter.days"
                @change="search"
                :label="$i18n.t('Days')"
              />
            </v-col>
            <v-col cols="12" sm="3" md="2" lg="2" v-if="filter.monthly">
              <v-select
                :items="monthList"
                v-model="filter.months"
                @change="search"
                :label="$i18n.t('Months')"
              />
            </v-col>
            <v-col
              cols="12"
              sm="3"
              md="2"
              lg="2"
              v-if="!filter.monthly && filter.days == -1"
            >
              <z-date-picker
                :label="$i18n.t('From Date')"
                class="purple-input"
                v-model="filter.fromDate"
              />
            </v-col>
            <v-col
              cols="12"
              sm="3"
              md="2"
              lg="2"
              v-if="!filter.monthly && filter.days == -1"
            >
              <z-date-picker
                :label="$i18n.t('Till Date')"
                class="purple-input"
                v-model="filter.toDate"
                timestamp
              />
            </v-col>
            <v-col
              cols="12"
              sm="3"
              md="2"
              lg="2"
              v-if="filter.monthly && filter.months == -1"
            >
              <z-month-picker
                :label="$i18n.t('From Month')"
                class="purple-input"
                v-model="filter.fromMonth"
              />
            </v-col>
            <v-col
              cols="12"
              sm="3"
              md="2"
              lg="2"
              v-if="filter.monthly && filter.months == -1"
            >
              <z-month-picker
                :label="$i18n.t('Till Month')"
                class="purple-input"
                v-model="filter.toMonth"
                timestamp
              />
            </v-col>

            <v-col
              cols="12"
              sm="3"
              md="2"
              lg="2"
              v-if="filter.type != 'general'"
            >
              <v-select
                :label="$i18n.t(filter.type)"
                class="purple-input"
                v-model="filter.entity_id"
                :items="dataSet"
              />
            </v-col>

            <v-col cols="12" sm="12" md="3" lg="2" class="text-right">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="mr-0"
                    color="grey darken"
                    fab
                    text
                    small
                    @click="clear(1)"
                    style="margin-right: 10px !important"
                    v-on="on"
                  >
                    <v-icon>mdi-cached</v-icon>
                  </v-btn>
                </template>
                <span>{{ $i18n.t("Clear Filter") }}</span>
              </v-tooltip>
              <v-btn
                color="success"
                class="mr-3"
                fab
                small
                dark
                @click="search()"
                :loading="loading"
                v-if="
                  (filter.monthly && filter.months == -1) ||
                  (!filter.monthly && filter.days == -1)
                "
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </base-material-card>
      </v-col>
    </v-row>
    <v-row v-if="false">
      <base-material-chart-card
        :data="dailySalesChart.data"
        :options="dailySalesChart.options"
        color="cyan lighten-5"
        hover-reveal
        type="Line"
        chart-inside-header
        background-color="green"
      >
        <template v-slot:reveal-actions>
          <v-tooltip bottom>
            <template v-slot:activator="{ attrs, on }">
              <v-btn v-bind="attrs" color="info" icon v-on="on">
                <v-icon color="info"> mdi-refresh </v-icon>
              </v-btn>
            </template>

            <span>Refresh</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ attrs, on }">
              <v-btn v-bind="attrs" light icon v-on="on">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>

            <span>Change Date</span>
          </v-tooltip>
        </template>

        <h4 class="card-title font-weight-light mt-2 ml-2">Daily Sales</h4>

        <p class="d-inline-flex font-weight-light ml-2 mt-1">
          <v-icon color="green" small> mdi-arrow-up </v-icon>
          <span class="green--text">55%</span>&nbsp; increase in today's sales
        </p>

        <template v-slot:actions>
          <v-icon class="mr-1" small> mdi-clock-outline </v-icon>
          <span class="caption grey--text font-weight-light"
            >updated 4 minutes ago</span
          >
        </template>
      </base-material-chart-card>
    </v-row>

    <v-row>
      <v-simple-table
        dense
        v-if="
          filter.type == 'general' && revenueReport && revenueReport.length > 0
        "
      >
        <thead>
          <tr>
            <th>
              <b>{{ $i18n.t("Organization") }}</b>
            </th>
            <th scope="col">
              <b>{{ $i18n.t("Head") }}</b>
            </th>
            <th
              scope="col"
              v-for="(rReport, i) in revenueReport"
              :key="i + 'revenue_report'"
            >
              <b>{{ RevenueHelper.getFormattedDateOrMonth(rReport.span) }}</b
              ><br />
            </th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td rowspan="11" style="width: 100px">
              {{ revenueReport[0].corp_id }}
            </td>
            <th scope="row" v-show="showRevenue">Revenue</th>
            <td
              v-show="showRevenue"
              v-for="(rReport, i) in revenueReport"
              :key="i + 'rr_showRevenue'"
            >
              <span
                v-for="(key, val) in rReport.revenue.revenue"
                :key="val + key + 'showRevenue'"
                >{{ val + " " }}{{ CommonUtil.roundCurrency2Decimal(key) }}<br
              /></span>
            </td>
          </tr>
          <tr v-show="showTaxes">
            <th scope="row">Taxes</th>
            <td v-for="(rReport, i) in revenueReport" :key="i + 'rr_showTaxes'">
              <span
                v-for="(key, val) in rReport.revenue.taxes"
                :key="val + key + 'showTaxes'"
                >{{ val + " " }}{{ CommonUtil.roundCurrency2Decimal(key) }}<br
              /></span>
            </td>
          </tr>
          <tr v-show="showFuel">
            <th scope="row">Fuel</th>
            <td v-for="(rReport, i) in revenueReport" :key="i + 'rr_showFuel'">
              <span
                v-for="(key, val) in rReport.revenue.fuel"
                :key="val + key + 'showFuel'"
                >{{ val + " " }}{{ CommonUtil.roundCurrency2Decimal(key) }}<br
              /></span>
            </td>
          </tr>
          <tr v-show="showSupplierFuel">
            <th scope="row">Supplier Fuel</th>
            <td
              v-for="(rReport, i) in revenueReport"
              :key="i + 'rr_showSupplierFuel'"
            >
              <span
                v-for="(key, val) in rReport.revenue.supplierFuel"
                :key="val + key + 'showSupplierFuel'"
                >{{ val + " " }}{{ CommonUtil.roundCurrency2Decimal(key) }}<br
              /></span>
            </td>
          </tr>
          <tr v-show="showExpenses">
            <th scope="row">Expenses</th>
            <td
              v-for="(rReport, i) in revenueReport"
              :key="i + 'rr_showExpenses'"
            >
              <span
                v-for="(key, val) in rReport.revenue.expense"
                :key="val + key + 'showExpenses'"
                >{{ val + " " }}{{ CommonUtil.roundCurrency2Decimal(key) }}<br
              /></span>
            </td>
          </tr>
          <tr v-show="showPayables">
            <th scope="row">Payables</th>
            <td
              v-for="(rReport, i) in revenueReport"
              :key="i + 'rr_showPayables'"
            >
              <span
                v-for="(key, val) in rReport.revenue.payables"
                :key="val + key + 'showPayables'"
                >{{ val + " " }}{{ CommonUtil.roundCurrency2Decimal(key) }}<br
              /></span>
            </td>
          </tr>
          <tr v-show="showEarnings">
            <th scope="row">Earnings</th>
            <td
              v-for="(rReport, i) in revenueReport"
              :key="i + 'rr_showEarnings'"
            >
              <span
                v-for="(key, val) in rReport.revenue.earnings"
                :key="val + key + 'showEarnings'"
                >{{ val + " " }}{{ CommonUtil.roundCurrency2Decimal(key) }}<br
              /></span>
            </td>
          </tr>
          <tr v-show="showRealised">
            <th scope="row">Realised</th>
            <td
              v-for="(rReport, i) in revenueReport"
              :key="i + 'rr_showRealised'"
            >
              <span
                v-for="(key, val) in rReport.revenue.realised"
                :key="val + key + 'showRealised'"
                >{{ val + " " }}{{ CommonUtil.roundCurrency2Decimal(key) }}<br
              /></span>
            </td>
          </tr>
          <tr v-show="showCash">
            <th scope="row">Cash</th>
            <td v-for="(rReport, i) in revenueReport" :key="i + 'rr_showCash'">
              <span
                v-for="(key, val) in rReport.revenue.cash"
                :key="val + key + 'showCash'"
                >{{ val + " " }}{{ CommonUtil.roundCurrency2Decimal(key) }}<br
              /></span>
            </td>
          </tr>
          <tr v-show="showSalary">
            <th scope="row">Salary</th>
            <td
              v-for="(rReport, i) in revenueReport"
              :key="i + 'rr_showSalary'"
            >
              <span
                v-for="(key, val) in rReport.revenue.salary"
                :key="val + key + 'showSalary'"
                >{{ val + " " }}{{ CommonUtil.roundCurrency2Decimal(key) }}<br
              /></span>
            </td>
          </tr>
          <tr v-show="showSalaryAdvance">
            <th scope="row">Salary Advance</th>
            <td
              v-for="(rReport, i) in revenueReport"
              :key="i + 'rr_showSalaryAdvance'"
            >
              <span
                v-for="(key, val) in rReport.revenue.salaryAdvance"
                :key="val + key + 'showSalaryAdvance'"
                >{{ val + " " }}{{ CommonUtil.roundCurrency2Decimal(key) }}<br
              /></span>
            </td>
          </tr>
        </tbody>
      </v-simple-table>

      <v-simple-table
        dense
        v-if="
          filter.type != 'general' && revenueReport && revenueReport.length > 0
        "
      >
        <thead>
          <tr>
            <th>
              <b>{{ $i18n.t("Organization") }}</b>
            </th>
            <th scope="col">
              <b>{{ $i18n.t("Head") }}</b>
            </th>
            <th
              scope="col"
              v-for="(span, i) in times"
              :key="i + 'span_revenue_report'"
            >
              <b>{{ RevenueHelper.getFormattedDateOrMonth(span) }}</b
              ><br />
            </th>
          </tr>
        </thead>

        <tbody
          v-for="(data, i) in dataSet"
          v-show="!filter.entity_id || filter.entity_id == data"
          :key="i + 'data_key'"
        >
          <tr>
            <td rowspan="10" style="width: 100px">
              {{ data }}
            </td>
            <th v-show="showRevenue" scope="row">
              {{ $i18n.t("Revenue") }}
            </th>
            <td
              v-show="showRevenue"
              v-for="(span, i) in times"
              :key="i + 'span'"
            >
              <span
                v-for="(key, val) in showValueFor(
                  filter.type,
                  data,
                  span,
                  'revenue'
                )"
                :key="key + val + 'dataset_showRevenue'"
                >{{ val + " " }}{{ CommonUtil.roundCurrency2Decimal(key) }}<br
              /></span>
            </td>
          </tr>
          <tr v-show="showTaxes">
            <th scope="row">Taxes</th>
            <td v-for="(span, i) in times" :key="i + 'span'">
              <span
                v-for="(key, val) in showValueFor(
                  filter.type,
                  data,
                  span,
                  'taxes'
                )"
                :key="key + val + 'dataset_showTaxes'"
                >{{ val + " " }}{{ CommonUtil.roundCurrency2Decimal(key) }}<br
              /></span>
            </td>
          </tr>
          <tr v-show="showFuel">
            <th scope="row">Fuel</th>
            <td v-for="(span, i) in times" :key="i + 'span'">
              <span
                v-for="(key, val) in showValueFor(
                  filter.type,
                  data,
                  span,
                  'fuel'
                )"
                :key="key + val + 'dataset_showFuelshowRevenue'"
                >{{ val + " " }}{{ CommonUtil.roundCurrency2Decimal(key) }}<br
              /></span>
            </td>
          </tr>
          <tr v-show="showSupplierFuel">
            <th scope="row">Supplier Fuel</th>
            <td v-for="(span, i) in times" :key="i + 'span'">
              <span
                v-for="(key, val) in showValueFor(
                  filter.type,
                  data,
                  span,
                  'supplierFuel'
                )"
                :key="key + val + 'dataset_showSupplierFuel'"
                >{{ val + " " }}{{ CommonUtil.roundCurrency2Decimal(key) }}<br
              /></span>
            </td>
          </tr>
          <tr v-show="showExpenses">
            <th scope="row">Expenses</th>
            <td v-for="(span, i) in times" :key="i + 'span'">
              <span
                v-for="(key, val) in showValueFor(
                  filter.type,
                  data,
                  span,
                  'expense'
                )"
                :key="key + val + 'dataset_showExpenses'"
                >{{ val + " " }}{{ CommonUtil.roundCurrency2Decimal(key) }}<br
              /></span>
            </td>
          </tr>
          <tr v-show="showPayables">
            <th scope="row">Payables</th>
            <td v-for="(span, i) in times" :key="i + 'span'">
              <span
                v-for="(key, val) in showValueFor(
                  filter.type,
                  data,
                  span,
                  'payables'
                )"
                :key="key + val + 'dataset_showPayables'"
                >{{ val + " " }}{{ CommonUtil.roundCurrency2Decimal(key) }}<br
              /></span>
            </td>
          </tr>
          <tr v-show="showOpeningBalance && filter.monthly">
            <th scope="row">Opening Balance</th>
            <td v-for="(span, i) in times" :key="i + 'span'">
              <span
                v-for="(key, val) in showValueFor(
                  filter.type,
                  data,
                  span,
                  'openingbalance'
                )"
                :key="key + val + 'dataset_showOpeningBalance'"
                >{{ val + " " }}{{ CommonUtil.roundCurrency2Decimal(key) }}<br
              /></span>
            </td>
          </tr>
          <tr v-show="showEarnings">
            <th scope="row">Earnings</th>
            <td v-for="(span, i) in times" :key="i + 'span'">
              <span
                v-for="(key, val) in showValueFor(
                  filter.type,
                  data,
                  span,
                  'earnings'
                )"
                :key="key + val + 'dataset_showEarnings'"
                >{{ val + " " }}{{ CommonUtil.roundCurrency2Decimal(key) }}<br
              /></span>
            </td>
          </tr>
          <tr v-show="showRealised">
            <th scope="row">Realised</th>
            <td v-for="(span, i) in times" :key="i + 'span'">
              <span
                v-for="(key, val) in showValueFor(
                  filter.type,
                  data,
                  span,
                  'realised'
                )"
                :key="key + val + 'dataset_showRealised'"
                >{{ val + " " }}{{ CommonUtil.roundCurrency2Decimal(key) }}<br
              /></span>
            </td>
          </tr>
          <tr v-show="showCash">
            <th scope="row">Cash</th>
            <td v-for="(span, i) in times" :key="i + 'span'">
              <span
                v-for="(key, val) in showValueFor(
                  filter.type,
                  data,
                  span,
                  'cash'
                )"
                :key="key + val + 'dataset_showCash'"
                >{{ val + " " }}{{ CommonUtil.roundCurrency2Decimal(key) }}<br
              /></span>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import { RevenueHelper } from "@/views/reports/revenue/revenueHelper";
import { CommonUtil } from "@/js/commonUtil";

@Component({
  name: "GeneralRevenue",
})
export default class GeneralRevenue extends Vue {
  revenueReport = [];
  RevenueHelper = RevenueHelper;
  CommonUtil = CommonUtil;
  url = "/api/revenue/report?&";
  filterPOSO = {
    monthly: this.false,
    type: "Revenue Report",
    days: "15",
    months: "3",
    fromDate: null,
    toDate: null,
    fromMonth: null,
    toMonth: null,
    entity_id: null,
  };
  showRevenue = true;
  showTaxes = true;
  showFuel = true;
  showSupplierFuel = true;
  showExpenses = true;
  showPayables = true;
  showOpeningBalance = true;
  showEarnings = true;
  showRealised = true;
  showCash = true;
  showSalary = true;
  showSalaryAdvance = true;
  filter = this.filterPOSO;
  dayList = [
    { value: "15", text: "Last 15 Days" },
    { value: "30", text: "Last 30 Days" },
    { value: "60", text: "Last 60 Days" },
    { value: "90", text: "Last 90 Days" },
    { value: "-1", text: "Other" },
  ];
  monthList = [
    { value: "3", text: "Last 15 Months" },
    { value: "6", text: "Last 30 Months" },
    { value: "9", text: "Last 60 Months" },
    { value: "12", text: "Last 90 Months" },
    { value: "-1", text: "Other" },
  ];
  times = [];
  dataSet = [];
  dailySalesChart = {
    data: {
      labels: ["M", "T", "W", "T", "F", "S", "S"],
      series: [
        [12, 17, 7, 17, 23, 18, 38],
        [112, 171, 17, 117, 123, 118, 318],
        [100, 117, 71, 127, 233, 138, 338],
      ],
    },
    options: {
      lineSmooth: this.$chartist.Interpolation.cardinal({
        tension: 0,
      }),
      low: 0,
      width: "800px",
      height: "800px",

      high: 500,
      chartPadding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
      },
    },
  };

  /**
   * type :  client/bu/supplier
   * entity :  client_id/bu_id
   * time: span (2019-10-12)
   * kind: revenue/cash/paybles
   */
  showValueFor(type, entity, time, kind) {
    if (!this.revenueReport) return;
    for (let i = 0; i < this.revenueReport.length; i++) {
      if (time == this.revenueReport[i].span) {
        if (type == "client") {
          for (
            let j = 0;
            j < this.revenueReport[i].clientRevenues.length;
            j++
          ) {
            if (entity == this.revenueReport[i].clientRevenues[j].client_id) {
              if (kind == "openingbalance") {
                return this.revenueReport[i].clientRevenues[j].openingBalance;
              } else {
                return this.revenueReport[i].clientRevenues[j].revenue[kind];
              }
            }
          }
        } else if (type == "bu") {
          for (
            let j = 0;
            j < this.revenueReport[i].entityRevenues.length;
            j++
          ) {
            if (entity == this.revenueReport[i].entityRevenues[j].bu_id) {
              return this.revenueReport[i].entityRevenues[j].revenue[kind];
            }
          }
        } else if (type == "supplier") {
          for (
            let j = 0;
            j < this.revenueReport[i].supplierRevenues.length;
            j++
          ) {
            if (
              entity == this.revenueReport[i].supplierRevenues[j].supplier_id
            ) {
              return this.revenueReport[i].supplierRevenues[j].revenue[kind];
            }
          }
        } else if (type == "vehicle") {
          for (
            let j = 0;
            j < this.revenueReport[i].vehicleRevenues.length;
            j++
          ) {
            if (entity == this.revenueReport[i].vehicleRevenues[j].regNo) {
              return this.revenueReport[i].vehicleRevenues[j].revenue[kind];
            }
          }
        } else if (type == "driver") {
          for (
            let j = 0;
            j < this.revenueReport[i].driverRevenues.length;
            j++
          ) {
            if (entity == this.revenueReport[i].driverRevenues[j].name) {
              return this.revenueReport[i].driverRevenues[j].revenue[kind];
            }
          }
        } else if (type == "user") {
          for (let j = 0; j < this.revenueReport[i].userRevenues.length; j++) {
            if (entity == this.revenueReport[i].userRevenues[j].name) {
              return this.revenueReport[i].userRevenues[j].revenue[kind];
            }
          }
        }
      }
    }
    return null;
  }

  populateTimes(response) {
    this.times = [];
    const entities = [];
    const clients = [];
    const suppliers = [];
    const vehicles = [];
    const drivers = [];
    const users = [];
    if (response && response.length > 0) {
      for (let i = 0; i < response.length; i++) {
        if (this.times.indexOf(response[i].span) == -1) {
          this.times.push(response[i].span);
        }
        if (
          response[i].entityRevenues &&
          response[i].entityRevenues.length > 0
        ) {
          for (let j = 0; j < response[i].entityRevenues.length; j++) {
            if (entities.indexOf(response[i].entityRevenues[j].bu_id) == -1) {
              entities.push(response[i].entityRevenues[j].bu_id);
            }
          }
        }
        if (
          response[i].clientRevenues &&
          response[i].clientRevenues.length > 0
        ) {
          for (let j = 0; j < response[i].clientRevenues.length; j++) {
            if (
              clients.indexOf(response[i].clientRevenues[j].client_id) == -1
            ) {
              clients.push(response[i].clientRevenues[j].client_id);
            }
          }
        }
        if (
          response[i].supplierRevenues &&
          response[i].supplierRevenues.length > 0
        ) {
          for (let j = 0; j < response[i].supplierRevenues.length; j++) {
            if (
              suppliers.indexOf(response[i].supplierRevenues[j].supplier_id) ==
              -1
            ) {
              suppliers.push(response[i].supplierRevenues[j].supplier_id);
            }
          }
        }
        if (
          response[i].vehicleRevenues &&
          response[i].vehicleRevenues.length > 0
        ) {
          for (let j = 0; j < response[i].vehicleRevenues.length; j++) {
            if (vehicles.indexOf(response[i].vehicleRevenues[j].regNo) == -1) {
              vehicles.push(response[i].vehicleRevenues[j].regNo);
            }
          }
        }
        if (
          response[i].driverRevenues &&
          response[i].driverRevenues.length > 0
        ) {
          for (let j = 0; j < response[i].driverRevenues.length; j++) {
            if (drivers.indexOf(response[i].driverRevenues[j].name) == -1) {
              drivers.push(response[i].driverRevenues[j].name);
            }
          }
        }
        if (response[i].userRevenues && response[i].userRevenues.length > 0) {
          for (let j = 0; j < response[i].userRevenues.length; j++) {
            if (users.indexOf(response[i].userRevenues[j].name) == -1) {
              users.push(response[i].userRevenues[j].name);
            }
          }
        }
      }
    }
    if (this.filter.type == "client") {
      this.dataSet = clients;
    } else if (this.filter.type == "entity") {
      this.dataSet = entities;
    } else if (this.filter.type == "supplier") {
      this.dataSet = suppliers;
    } else if (this.filter.type == "vehicle") {
      this.dataSet = vehicles;
    } else if (this.filter.type == "driver") {
      this.dataSet = drivers;
    } else if (this.filter.type == "user") {
      this.dataSet = users;
    }
  }

  setReportType(type) {
    // destroyAllCharts();
    // hideAllChartDivs();
    //     if(this.filter.type === 'Revenue Report'){
    //       var chartData = extrctDataForLine(this.revenueReport, 'INR');
    //       drawLineChart('revenue_history_chart', chartData.dataSets, chartData.labels, 'Total Revenue', 300);
    //       $('.line_chart_div').show();
    //     } else if(this.filter.type === 'Client-wise Report'){
    //       showPieChartsForClientSupplier(filter.type, 'INR');
    //     } else if(this.filter.type === 'Business-Unit-wise Report'){
    //       showPieChartsForBu('INR');
    //     } else if(this.filter.type === 'Supplier-wise Report'){
    //       showPieChartsForClientSupplier('supplier', 'INR');
    //     } else if(this.filter.type === 'Vehicle-wise Report'){
    //       showPieChartsForVehicle('INR');
    //    } else if(this.filter.type === 'Driver-wise Report'){
    //       showPieChartsForDriver('INR');
    //    } else if(this.filter.type === 'User-wise Report'){
    //       showPieChartsForUser('INR');
    //     }
  }

  async search() {
    this.filterUrl = "";
    if (this.filter.monthly) {
      this.filterUrl += `monthly=true&months=${this.filter.months}`;
    } else {
      this.filterUrl += `monthly=false&days=${this.filter.days}`;
    }
    common.setLoading(true);
    await this.showPage();
  }

  async showPage() {
    common.setLoading(true);
    try {
      const response = await doGet(this.url + this.filterUrl);
      this.populateTimes(response);
      this.revenueReport = response;
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  async mounted() {
    if (this.$route.params.type) {
      if (
        [
          "general",
          "client",
          "entity",
          "supplier",
          "vehicle",
          "driver",
          "user",
        ].indexOf(this.$route.params.type) == -1
      ) {
        this.$router.push("/reports/revenue/general");
      }
      this.filter.type = this.$route.params.type;
    } else {
      this.filter.type = "general";
    }
    this.search();
  }

  async clear() {
    this.filter = this.filterPOSO;
    this.search();
  }

  get loading() {
    return common.loading;
  }

  get gridHeight() {
    return this.windowHeight > 500 ? this.windowHeight - 150 : 300;
  }

  get itemHeight() {
    return this.windowWidth > 960 ? 75 : 240;
  }
}
</script>

<style scoped>
.filter-close {
  position: absolute;
  right: 5px;
  top: 5px;
}
.dialog {
  position: fixed;
  top: 100px;
  width: 60%;
  z-index: 10;
  margin-left: 15%;
}
.sticky-bottom {
  position: sticky;
  bottom: 0;
  background-color: white;
  border-top: 1px solid #dfdfdf;
}
.sticky-top {
  position: sticky;
  top: 0;
  z-index: 2;
}

.v-card__subtitle,
.v-card__text {
  font-size: 14px;
}

.v-expansion-panel-header--active {
  background-color: aliceblue;
  min-height: 50px !important;
}

tbody:nth-child(even) {
  background: #fafafa;
}
.thead tr th {
  padding: 0 2px !important;
}

#line-chart {
  background-color: rgb(55, 71, 79);
  width: 800px;
  height: 350px;
  font-family: Lato, Helvetica-Neue, monospace;
}
.ct-series-a .ct-line {
  stroke: #00a79d;
}
.ct-series-b .ct-line {
  stroke: #1c75bc;
}
.ct-series-c .ct-line {
  stroke: #92278f;
}
.ct-series-a .ct-point {
  stroke: #00a79d;
}
.ct-series-b .ct-point {
  stroke: #1c75bc;
}
.ct-series-c .ct-point {
  stroke: #92278f;
}
.ct-label {
  color: white;
}

/* Use this selector to override the line style on a given series */
.ct-series-a .ct-line {
  /* Set the colour of this series line */
  stroke: red;
  /* Control the thikness of your lines */
  stroke-width: 5px;
  /* Create a dashed line with a pattern */
  stroke-dasharray: 10px 20px;
}

/* This selector overrides the points style on line charts. Points on line charts are actually just very short strokes. This allows you to customize even the point size in CSS */
.ct-series-a .ct-point {
  /* Colour of your points */
  stroke: red;
  /* Size of your points */
  stroke-width: 20px;
  /* Make your points appear as squares */
  stroke-linecap: square;
}
</style>
